import { useState, useEffect, useRef } from 'react';

import { getThumbnailSize } from '../components/video/getVideoContainerData';

interface Props {
  clips: any[];
  isCollapsed: boolean;
  isPortrait: boolean;
  isBig?: boolean;
}

const useVisibleClips = ({ clips, isCollapsed, isPortrait, isBig }: Props) => {
  const [clipsPerRow, setClipsPerRow] = useState(8);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateClipsPerRow = () => {
      if (!containerRef.current) return;

      const containerWidth = containerRef.current.offsetWidth;
      const gap = isBig ? 24 : 16;

      // create temp element to measure calculated width
      const tempEl = document.createElement('div');
      tempEl.className = getThumbnailSize(isPortrait, isBig).thumbWidth;

      tempEl.style.visibility = 'hidden';
      document.body.appendChild(tempEl);

      const clipWidth = tempEl.getBoundingClientRect().width;
      document.body.removeChild(tempEl);

      const calculated = Math.floor(
        (containerWidth + gap) / (clipWidth + gap) + 0.01,
      );

      setClipsPerRow((prev) => (prev !== calculated ? calculated : prev));
    };

    updateClipsPerRow();
    window.addEventListener('resize', updateClipsPerRow);
    return () => window.removeEventListener('resize', updateClipsPerRow);
  }, [isPortrait, isBig]);

  const rowsNum = clipsPerRow <= 4 ? 2 : 1;
  const maxClips = clipsPerRow * rowsNum;

  let visibleClips = [...clips];
  let showViewAllBtn = false;

  if (clips.length > maxClips) {
    visibleClips = isCollapsed ? clips.slice(0, maxClips - 1) : clips;
    showViewAllBtn = true;
  }

  return { visibleClips, showViewAllBtn, containerRef };
};

export default useVisibleClips;
